import { get } from 'lodash';
import urlJoin from 'url-join';

const YOLA_CMS_PREFIX = 'yolacms';

function addPrefix(prefix, url) {
  return `${prefix ? `/${prefix}` : ''}${url}`;
}

class Configuration {
  static get() {
    if (this.instance instanceof Configuration) {
      return this.instance;
    }

    this.instance = new Configuration(window.CONFIGURATION);

    return this.instance;
  }

  constructor(configuration) {
    this.configuration = configuration;
  }

  get(path) {
    if (!path) {
      return this.configuration;
    }

    return get(this.configuration, path);
  }

  // eslint-disable-next-line class-methods-use-this
  getDashboardUrl() {
    return '/cms-dashboard';
  }

  // eslint-disable-next-line class-methods-use-this
  getLoginUrl(options = {}) {
    const { prefix } = options;

    return addPrefix(prefix, '/cms-login');
  }

  // eslint-disable-next-line class-methods-use-this
  getLogoutUrl() {
    return '/cms-logout';
  }

  // eslint-disable-next-line class-methods-use-this
  getSignupUrl(options = {}) {
    const { prefix } = options;

    return addPrefix(prefix, '/cms-signup');
  }

  // eslint-disable-next-line class-methods-use-this
  getTemplateGalleryUrl(options = {}) {
    const { prefix } = options;

    return addPrefix(prefix, '/cms-gallery');
  }

  getPublicApiUrl() {
    return this.configuration.common['public-api-gateway'].url;
  }

  getBasePath() {
    return urlJoin(get(this.configuration, 'yolacom.cms.cdn_base_url'), YOLA_CMS_PREFIX);
  }

  getLocaleCookieName() {
    return this.configuration.common.authtkt.current_language_cookie;
  }

  getDomainForLocaleCookie() {
    return this.configuration.common.authtkt.cookie_domain;
  }

  getBaseLanguageCodes() {
    return this.configuration.common.language_codes.base;
  }

  getMyyolaUrl() {
    return this.configuration.common.myyola.url;
  }
}

export default Configuration;
